import { API, api } from "./api";

export const fmtSize = (b) => {
  if (b < 1024) return `${b} B`;
  if (b < 1048576) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1048576).toFixed(1)} MB`;
};

async function putChunk(url, blob) {
  try {
    await api.put(url, blob, { headers: { "Content-Type": "application/octet-stream" } });
  } catch (e) {
    if (e?.response?.status && e.response.status < 500) throw e;
    await api.put(url, blob, { headers: { "Content-Type": "application/octet-stream" } });
  }
}

// Chunked upload: each piece stays under the 1 MB request limit
export async function uploadFile(file, kind, onProgress) {
  const { data: s } = await api.post("/app/uploads", { filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, kind });
  for (let i = 0; i < s.chunks; i++) {
    await putChunk(`/app/uploads/${s.upload_id}/chunks/${i}`, file.slice(i * s.chunk_size, (i + 1) * s.chunk_size));
    onProgress?.(Math.round(((i + 1) / s.chunks) * 100));
  }
  const { data } = await api.post(`/app/uploads/${s.upload_id}/complete`);
  return data;
}

export async function downloadFile(f) {
  const { data } = await api.get(`/app/files/${f.id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = f.filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Reads a server-sent-events POST response and reports the growing text
export async function streamPost(path, onText) {
  const ws = localStorage.getItem("cario_ws");
  const run = () => fetch(`${API}${path}`, { method: "POST", credentials: "include", headers: ws ? { "X-Workspace-Id": ws } : {} });
  let res = await run();
  if (res.status === 401) { await fetch(`${API}/auth/refresh`, { method: "POST", credentials: "include" }); res = await run(); }
  if (!res.ok) {
    let d = null;
    try { d = (await res.json()).detail; } catch (parseErr) { console.warn("Error response was not JSON", parseErr); }
    throw new Error(typeof d === "string" ? d : "Request failed. Please try again.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let text = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.delta) { text += ev.delta; onText(text); }
    }
  }
  return text;
}
